export default __webpack_public_path__ + "static/media/asc.4f0f503c.svg";